<template>
  <ul class="list-line-items">
    <li v-for="(lineItem, index) in lineItems" :key="lineItem.identify">
      <LineItem :config="{ line_item: lineItem, editable, index }" class="item-line-item w-100" :data-id="lineItem.identify"></LineItem>
    </li>
  </ul>
</template>

<script>
import LineItem from './LineItem.vue'
export default {
  components: {
    LineItem
  },
  computed: {
    row() {
      return this.config?.row || {}
    },
    editable() {
      return {}
    },
    lineItems() {
      return this.row?.[this.config?.key] || {}
    }
  },
  props: {
    config: Object
  }
}
</script>
<style lang="scss">
.table-list ul.list-line-items {
  list-style: none;
}
</style>
